import { Component, input, ViewEncapsulation, inject } from '@angular/core';
import { NgControl, FormsModule } from '@angular/forms';
import { NgTemplateOutlet } from '@angular/common';

import { ApContentService } from '@ap/content';
import { AbstractInputComponent, ApOptions, InputType } from '@ap/input';
import { ApInputConstraintService } from '@ap/input/constraint';
import { ApFormErrorsComponent } from '@ap/form/errors';
import { ApNotificationComponent } from '@ap/notification';
import { ApContentPipe } from '@ap/content';

import content from './password-input.content.json';

@Component({
    selector: 'ap-password-input',
    templateUrl: './password-input.component.html',
    styleUrls: ['../../../src/lib/input.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [FormsModule, ApFormErrorsComponent, ApNotificationComponent, ApContentPipe, NgTemplateOutlet],
    providers: [ApInputConstraintService]
})
export class ApPasswordInputComponent extends AbstractInputComponent {
    protected control = inject(NgControl, { self: true, optional: true });
    protected readonly inputConstraintService = inject(ApInputConstraintService);
    protected readonly contentService = inject(ApContentService);

    /**
     * Password type input
     */
    protected readonly type = input<InputType>('password');

    /**
     * Boolean to check if caps lock is on.
     * Shows caps lock notification if true
     */
    protected capsLockOn = false;

    override readonly options = input<ApOptions>(null);

    constructor() {
        super();
        this.setDefaultContent(content, 'password-input');
    }

    /**
     * Check if caps lock is on.
     */
    protected setCapsLockState(event: any): void {
        if (!event.getModifierState) {
            return;
        }

        if (event.key === 'CapsLock') {
            this.capsLockOn = !this.capsLockOn && event.getModifierState('CapsLock');
            return;
        }

        this.capsLockOn = event.getModifierState('CapsLock');
    }
}
